import React, { useContext, useEffect, useState } from "react";
import InputForm from "../../Components/InputForm/InputForm";
import Table from "react-bootstrap/Table";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../../Components/Modal/CustomModal";
import { Modal, Button } from "react-bootstrap";
import { APICall } from "../../Helpers/Network/APICalls";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import {
  GetDemandRecoveryForm,
  InsertLongLoanEmailSMS,
  InsertShortLoanEmailSMS,
} from "../../Helpers/APIEndPoints/EndPoints";
import "./DemandRecovery.css";
import Checkbox from "../../Components/Checkbox/Checkbox";

const DemandRecoveryForm = () => {
  let navigate = useNavigate();
  const [dashboardLongData, setDashboardLongData] = useState({
    intRate: 0,
    AROI: 0,
    POI: 0,
    BalAmt: 0,
    BalAmtAL: 0,
    LastEmiDate: null,
    EMI: 0,
    EmiAmountAL: 0,
    PenMonth: 0,
    LoanAmount: 0,
  });
  const [dashboardShortData, setDashboardShortData] = useState({
    intRate: 0,
    POI: 0,
    BalAmt: 0,
    LastEmiDate: null,
    EMI: 0,
    PenMonth: 0,
    LoanAmount: 0,
  });
  const { state } = useLocation();
  const DRMemberId = state ? state.memberId : null;
  const [show, setShow] = useState(false);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [modalOpen, setModalOpen] = useState(false);
  // State to hold suretyDetails data
  const [suretyLongDetails, setSuretyLongDetails] = useState([]);
  const [suretyShortDetails, setSuretyShortDetails] = useState([]);
  const [isLongSuretyDetailsAvailable, setIsLongSuretyDetailsAvailable] =
    useState(false);
  const [isShortSuretyDetailsAvailable, setIsShortSuretyDetailsAvailable] =
    useState(false);
  const [loanType, setLoanType] = useState("");
  const [longLoanReqId, setLongLoanReqId] = useState(0);
  const [shortLoanReqId, setShortLoanReqId] = useState(0);
  const [shortTermChecked, setShortTermChecked] = useState(false);
  const [longTermChecked, setLongTermChecked] = useState(false);
  const [suretyShort, setSuretyShort] = useState("");
  const [suretyLong, setSuretyLong] = useState("");
  const context = getContext();

  const handleShortTermLoanClick = () => {
    setShow(false);
    setModalOpen(true);
    setLoanType("Short");
    setShortTermChecked(!shortTermChecked);
    // setHandleFunction(() => handleYesFunctionality("Short"));
  };

  const handleLongTermLoanClick = () => {
    setShow(false);
    setModalOpen(true);
    setLoanType("Long");
    setLongTermChecked(!longTermChecked);
    // setHandleFunction(() => handleYesFunctionality("Long"));
  };

  const handleShow = () => {
    
    // setShow(true);
    if (isLongSuretyDetailsAvailable && isShortSuretyDetailsAvailable) {
      setShow(true);
      // setLongTermChecked(false);
      // setShortTermChecked(false);
    } else if (isLongSuretyDetailsAvailable && !isShortSuretyDetailsAvailable) {
      setShow(false);
      setModalOpen(true);
      setLongTermChecked(true);
      setShortTermChecked(false);
    } else if (isShortSuretyDetailsAvailable && !isLongSuretyDetailsAvailable) {
      setShow(false);
      setModalOpen(true);
      setShortTermChecked(true);
      setLongTermChecked(false);
    }
  };

  const getDashboardData = async () => {
    debugger
    showLoader();

    try {
      let obj = {
        MemberId: DRMemberId,
      };
      const resp = await APICall(GetDemandRecoveryForm, obj);
      if (
        resp.Data?.demandLongRecoveryFormDetails?.length > 0 &&
        resp.Data?.demandShortRecoveryFormDetails?.length > 0
      ) {
        //Long  Term Loan
        const longRecoveryFormDetails =
          resp.Data?.demandLongRecoveryFormDetails[0];
        const loanLongId =
          resp.Data?.demandLongRecoveryFormDetails[0].LoanRequestId;
        setLongLoanReqId(loanLongId);
        //Short  term loan
        const shortRecoveryFormDetails =
          resp.Data?.demandShortRecoveryFormDetails[0];
        const loanShortId =
          resp.Data?.demandShortRecoveryFormDetails[0].LoanRequestId;
        setShortLoanReqId(loanShortId);

        // Set state for both long and short recovery form details
        setDashboardLongData({
          intRate: longRecoveryFormDetails.ROI,
          AROI: longRecoveryFormDetails.AROI,
          POI: longRecoveryFormDetails.InstallmentPeriod,
          BalAmt: longRecoveryFormDetails.BalanceAmt,
          LastEmiDate: longRecoveryFormDetails.LastEMIDate,
          EMI: longRecoveryFormDetails.EmiAmount,
          EmiAmountAL: longRecoveryFormDetails.EmiAmountAL,
          PenMonth: longRecoveryFormDetails.Month,
          LoanAmount: longRecoveryFormDetails.LoanAmount,
          BalAmtAL: longRecoveryFormDetails.AdditionalLoanAmount,
        });
        setSuretyLongDetails(
          longRecoveryFormDetails.MemberLongSuretyDetailsList
        );
        if (longRecoveryFormDetails.MemberLongSuretyDetailsList.length > 0) {
          const longSuretyMembers =
            resp.Data?.demandLongRecoveryFormDetails[0].MemberLongSuretyDetailsList.map(
              (detail) => detail.SuretyMember
            );
          const commaSeparatedLongSuretyMembers = longSuretyMembers.join(", ");
          setSuretyLong(commaSeparatedLongSuretyMembers);
          setIsLongSuretyDetailsAvailable(true);
        }

        setDashboardShortData({
          intRate: shortRecoveryFormDetails.ROI,
          POI: shortRecoveryFormDetails.InstallmentPeriod,
          BalAmt: shortRecoveryFormDetails.BalanceAmt,
          LastEmiDate: shortRecoveryFormDetails.LastEMIDate,
          EMI: shortRecoveryFormDetails.EmiAmount,
          PenMonth: shortRecoveryFormDetails.Month,
          LoanAmount: shortRecoveryFormDetails.LoanAmount,
        });
        if (shortRecoveryFormDetails.MemberShortSuretyDetailsList.length > 0) {
          const shortSuretyMembers =
            resp.Data?.demandShortRecoveryFormDetails[0].MemberShortSuretyDetailsList.map(
              (detail) => detail.SuretyMember
            );
          const commaSeparatedShortSuretyMembers =
            shortSuretyMembers.join(", ");

          setSuretyShort(commaSeparatedShortSuretyMembers);
          setIsShortSuretyDetailsAvailable(true);
        }
        setSuretyShortDetails(
          shortRecoveryFormDetails.MemberShortSuretyDetailsList
        );
      } else if (
        (resp.Data?.demandLongRecoveryFormDetails?.length > 0 &&
          resp.Data?.demandShortRecoveryFormDetails?.length == 0) ||
        null ||
        undefined
      ) {
        //Long  Term Loan
        const longRecoveryFormDetails =
          resp.Data?.demandLongRecoveryFormDetails[0];
        const loanLongId =
          resp.Data?.demandLongRecoveryFormDetails[0].LoanRequestId;
        setLongLoanReqId(loanLongId);
        setDashboardLongData({
          intRate: longRecoveryFormDetails.ROI,
          AROI: longRecoveryFormDetails.AROI,
          POI: longRecoveryFormDetails.InstallmentPeriod,
          BalAmt: longRecoveryFormDetails.BalanceAmt,
          LastEmiDate: longRecoveryFormDetails.LastEMIDate,
          EMI: longRecoveryFormDetails.EmiAmount,
          EmiAmountAL: longRecoveryFormDetails.EmiAmountAL,
          PenMonth: longRecoveryFormDetails.Month,
          LoanAmount: longRecoveryFormDetails.LoanAmount,
          BalAmtAL: longRecoveryFormDetails.AdditionalLoanAmount,
        });
        setSuretyLongDetails(
          longRecoveryFormDetails.MemberLongSuretyDetailsList
        );
        if (longRecoveryFormDetails.MemberLongSuretyDetailsList.length > 0) {
          const longSuretyMembers =
            resp.Data?.demandLongRecoveryFormDetails[0].MemberLongSuretyDetailsList.map(
              (detail) => detail.SuretyMember
            );

          const commaSeparatedLongSuretyMembers = longSuretyMembers.join(", ");
          setSuretyLong(commaSeparatedLongSuretyMembers);
          setIsLongSuretyDetailsAvailable(true);
        }
      } else if (
        (resp.Data?.demandShortRecoveryFormDetails?.length > 0 &&
          resp.Data?.demandLongRecoveryFormDetails?.length == 0) ||
        null ||
        undefined
      ) {
        const shortRecoveryFormDetails =
          resp.Data?.demandShortRecoveryFormDetails[0];
        const loanShortId =
          resp.Data?.demandShortRecoveryFormDetails[0].LoanRequestId;
        setShortLoanReqId(loanShortId);
        setDashboardShortData({
          intRate: shortRecoveryFormDetails.ROI,
          POI: shortRecoveryFormDetails.InstallmentPeriod,
          BalAmt: shortRecoveryFormDetails.BalanceAmt,
          LastEmiDate: shortRecoveryFormDetails.LastEMIDate,
          EMI: shortRecoveryFormDetails.EmiAmount,
          PenMonth: shortRecoveryFormDetails.Month,
          LoanAmount: shortRecoveryFormDetails.LoanAmount,
        });
        if (shortRecoveryFormDetails.MemberShortSuretyDetailsList.length > 0) {
          const shortSuretyMembers =
            resp.Data?.demandShortRecoveryFormDetails[0].MemberShortSuretyDetailsList.map(
              (detail) => detail.SuretyMember
            );
          const commaSeparatedShortSuretyMembers =
            shortSuretyMembers.join(", ");
          setSuretyShort(commaSeparatedShortSuretyMembers);
          setIsShortSuretyDetailsAvailable(true);
        }
        setSuretyShortDetails(
          shortRecoveryFormDetails.MemberShortSuretyDetailsList
        );
      } else {
        // If either long or short recovery form details is empty, set default state
        setDashboardLongData({
          intRate: 0,
          AROI: 0,
          POI: 0,
          BalAmt: 0,
          BalAmtAL: 0,
          LastEmiDate: null,
          EMI: 0,
          EmiAmountAL: 0,
          PenMonth: 0,
          LoanAmount: 0,
        });
        setSuretyLongDetails([]);

        setDashboardShortData({
          intRate: 0,
          POI: 0,
          BalAmt: 0,
          LastEmiDate: null,
          EMI: 0,
          PenMonth: 0,
          LoanAmount: 0,
        });
        setSuretyShortDetails([]);
      }
    } catch (err) {
     
    } finally {
      hideLoader();
    }
  };

  const handleCloseModal = () => {
    setShow(false);
    setModalOpen(false);
  };

  const handleClose = () => {
    setShow(false);
    setShortTermChecked(false);
    setLongTermChecked(false);
  };

  const onChange = (event, value) => {
    
    if (event === "ShortTerm") {
      setShortTermChecked(value);
      setLongTermChecked(false);
      setShow(true);
    } else if (event === "LongTerm") {
      setLongTermChecked(value);
      setShortTermChecked(false);
      setShow(true);
    }
  };
  // const onChange = (event) => {
  //   const { value } = event.target;
  //   if (value === "ShortTerm") {
  //     setShortTermChecked(true);
  //     setLongTermChecked(false);
  //     setShow(true);
  //   } else if (value === "LongTerm") {
  //     setLongTermChecked(true);
  //     setShortTermChecked(false);
  //     setShow(true);
  //   }
  // };

  const onSubmit = () => {
    setModalOpen(true);
    setShow(false);
  };

  const handleYesFunctionality = async () => {
    
    setModalOpen(true);
    try {
      // if (loanType === "Short") {
      if (shortTermChecked === true) {
        let obj = {
          LoanRequestId: shortLoanReqId,
          MemberId: DRMemberId,
          LoanMemberId: DRMemberId,
          SuretyMemberId: suretyShort,
          InitiateMemberId: context?.MemberId, //currentuser member id
          LoanType: 159,
          CreatedBy: context?.Id, //currentuser user id
        };
        const req = await APICall(InsertShortLoanEmailSMS, obj);
        // } else if (loanType === "Long") {
      } else if (longTermChecked === true) {
        let obj = {
          LoanRequestId: longLoanReqId,
          MemberId: DRMemberId,
          LoanMemberId: DRMemberId,
          SuretyMemberId: suretyLong,
          InitiateMemberId: context?.MemberId, //currentuser member id
          LoanType: 160,
          CreatedBy: context?.Id, //currentuser user id
        };
        const req = await APICall(InsertLongLoanEmailSMS, obj);
        // if (req.Message === "Success") {
        //   setLongTermChecked(false);
        //   // setShortTermChecked(false);
        // }
      }
    } catch (err) {
   
    } finally {
      setModalOpen(false);
      hideLoader();
    }
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <>
      <div className="container-fluid">
        <CustomModal
          show2={modalOpen}
          handleClose2={handleCloseModal}
          onHide2={() => setModalOpen(false)}
          title="Confirmation Message"
          body={"Are you sure you want to proceed ?"}
          hideButton1={false}
          buttonLabel1="Yes"
          handleYesFunctionality={handleYesFunctionality}
          buttonLabel2="No"
          hideButton2={false}
        />
        <Modal
          show={show}
          onHide={handleClose}
          // backdrop="static"
          keyboard={false}
        >
          <Modal.Header
            className="custom-modal-header my_close_btn"
            closeButton
          >
            <Modal.Title>Please Select one</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-center align-items-center">
              {isShortSuretyDetailsAvailable && (
                <div className="mr-4">
                  <Checkbox
                    id="ShortTerm"
                    title="Short Term Loan"
                    checked={shortTermChecked}
                    onChange={onChange}
                  />
                  {/* <input
                    type="radio"
                    id="ShortTerm"
                    name="loanType"
                    value="ShortTerm"
                    checked={shortTermChecked}
                    onChange={onChange}
                  /> */}
                  {/* <label htmlFor="ShortTerm">Short Term Loan</label> */}
                </div>
              )}

              {isLongSuretyDetailsAvailable && (
                <div className="mr-2">
                  <Checkbox
                    id="LongTerm"
                    title="Long Term Loan"
                    checked={longTermChecked}
                    onChange={onChange}
                  />
                  {/* <input
                    type="radio"
                    id="LongTerm"
                    name="loanType"
                    value="LongTerm"
                    checked={longTermChecked}
                    onChange={onChange}
                  /> */}
                  {/* <label htmlFor="LongTerm">Long Term Loan</label> */}
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-center align-items-center">
              {/* <div className="">
                <button
                  className="text-center schemesM_headBtn mr-3"
                  onClick={handleShortTermLoanClick}
                >
                  Short Term Loan
                </button>
              </div>
              <div>
                <button
                  className=" text-center schemesUnM_headBtn"
                  onClick={handleLongTermLoanClick}
                >
                  Long Term Loan
                </button>
              </div> */}
              <ButtonComponent
                icon={"far fa-times-circle"}
                className="btn btn-cancel"
                style={{ marginLeft: 5 }}
                onClick={handleClose}
                value={"Cancel"}
                id={"cancelBtn"}
              />
              <ButtonComponent
                icon={"fas fa-paper-plane"}
                value={"Submit"}
                style={{ marginLeft: "10px" }}
                id={"saveBtn"}
                onClick={onSubmit}
              />
            </div>
          </Modal.Footer>
        </Modal>
        {isLongSuretyDetailsAvailable && (
          <>
            <p className="schemesUnM_head ">Long Term</p>
            <div className="row ">
              <div className="col-lg-6 col-sm-6 col-xs-4 mx-auto">
                <div className="form-group ">
                  {/* Additional amount */}
                  <label>Loan Amount</label>
                  <InputForm
                    value={dashboardLongData.LoanAmount}
                    placeholder={"LoanAmount"}
                    isDisabled={true}
                    textArea={false}
                    onChange={"onSearchFilter"}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-sm-6 col-xs-4 mx-auto">
                <div className="form-group ">
                  {/* Additional amount */}
                  <label>Additional Loan Amount </label>
                  <InputForm
                    value={dashboardLongData.LoanAmount}
                    placeholder={"LoanAmount"}
                    isDisabled={true}
                    textArea={false}
                    onChange={"onSearchFilter"}
                  />
                </div>
              </div>
            </div>
            <div className="row ">
              {/* Intrest Rate */}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>Intrest Rate</label>
                  <InputForm
                    value={dashboardLongData.intRate}
                    placeholder={"Name"}
                    isDisabled={true}
                    textArea={false}
                    onChange={"onSearchFilter"}
                  />
                </div>
              </div>
              {/* Additional Intrest Rate */}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>Additional Lone Intrest Rate</label>
                  <InputForm
                    value={dashboardLongData.AROI}
                    placeholder={"Name"}
                    isDisabled={true}
                    textArea={false}
                    onChange={"onSearchFilter"}
                  />
                </div>
              </div>

              {/* Period of Installment */}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>Period of Installment</label>
                  <InputForm
                    placeholder={"Period of Installment "}
                    value={dashboardLongData.POI}
                    onChange={"handleAmountChange"}
                    type="text"
                    isDisabled={true}
                  />
                </div>
              </div>

              {/*Pending Month*/}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>Pending Month</label>
                  <InputForm
                    placeholder={"Pending Month"}
                    value={dashboardLongData.PenMonth}
                    onChange={(val: any) => {}}
                    isDisabled={true}
                  />
                </div>
              </div>

              {/* Balance Amount */}
              <div className="col-lg-6 col-sm-6 col-xs-4">
                <div className="form-group ">
                  <label>Balance Amount</label>
                  <InputForm
                    placeholder={"Balance Amount"}
                    maxlength={20}
                    value={dashboardLongData.BalAmt}
                    type="number"
                    isDisabled={true}
                    // onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div>

              {/* Balance Amount AL*/}
              <div className="col-lg-6 col-sm-6 col-xs-4">
                <div className="form-group ">
                  <label>Balance Amount Additiona Loan</label>
                  <InputForm
                    placeholder={"Balance Amount"}
                    maxlength={20}
                    value={dashboardLongData.BalAmtAL}
                    type="number"
                    isDisabled={true}
                    // onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div>

              {/* EMI */}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>EMI</label>
                  {/* <sup>*</sup> */}
                  <InputForm
                    placeholder={"EMI"}
                    type="number"
                    value={dashboardLongData.EMI}
                    onChange={"handleTRNChange"}
                    isDisabled={true}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div>

              {/* EMI AL*/}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>Additional Lone EMI</label>
                  {/* <sup>*</sup> */}
                  <InputForm
                    placeholder={"EMI"}
                    type="number"
                    value={dashboardLongData.EmiAmountAL}
                    onChange={"handleTRNChange"}
                    isDisabled={true}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div>

              {/* Last EMI Date */}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>Last EMI Date</label>
                  <InputForm
                    placeholder={"Last EMI Date"}
                    value={dashboardLongData.LastEmiDate}
                    onChange={(val: any) => {}}
                    isDisabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row ">
              <div className="col-lg-6 col-sm-6 col-xs-4 mx-auto">
                <Table striped bordered hover className="mt-3">
                  <thead>
                    <tr className="text-dark">
                      <th>Member No</th>
                      <th>Member Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {suretyLongDetails?.length === 0 ? (
                      <tr>
                        <td colSpan={2} className="text-center">
                          Sorry, no matching records found
                        </td>
                      </tr>
                    ) : (
                      suretyLongDetails?.map((detail, index) => (
                        <tr key={index}>
                          <td>{detail.SuretyMember}</td>
                          <td>{detail.FullName}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        )}

        {isShortSuretyDetailsAvailable && (
          <>
            <p className="schemesM_head">Short Term</p>

            <div className="row ">
              {/* Intrest Rate */}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>Intrest Rate</label>
                  <InputForm
                    value={dashboardShortData.intRate}
                    placeholder={"Name"}
                    isDisabled={true}
                    textArea={false}
                    onChange={"onSearchFilter"}
                  />
                </div>
              </div>

              {/* Period of Installment */}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>Period of Installment</label>
                  <InputForm
                    placeholder={"Period of Installment "}
                    value={dashboardShortData.POI}
                    onChange={"handleAmountChange"}
                    type="text"
                    isDisabled={true}
                  />
                </div>
              </div>

              {/*Pending Month*/}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>Pending Month</label>
                  <InputForm
                    placeholder={"Pending Month"}
                    value={dashboardShortData.PenMonth}
                    onChange={(val: any) => {}}
                    isDisabled={true}
                  />
                </div>
              </div>

              {/* Last EMI Date */}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>Last EMI Date</label>
                  <InputForm
                    placeholder={"Last EMI Date"}
                    value={dashboardShortData.LastEmiDate}
                    onChange={(val: any) => {}}
                    isDisabled={true}
                  />
                </div>
              </div>

              {/* Balance Amount */}
              <div className="col-lg-6 col-sm-6 col-xs-4">
                <div className="form-group ">
                  <label>Balance Amount</label>
                  <InputForm
                    placeholder={"Balance Amount"}
                    maxlength={20}
                    value={dashboardShortData.BalAmt}
                    type="number"
                    isDisabled={true}
                    // onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div>

              {/* EMI */}
              <div className="col-lg-6 col-sm-6 col-xs-4 ">
                <div className="form-group ">
                  <label>EMI</label>
                  {/* <sup>*</sup> */}
                  <InputForm
                    placeholder={"EMI"}
                    type="number"
                    value={dashboardShortData.EMI}
                    onChange={"handleTRNChange"}
                    isDisabled={true}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div>
            </div>
            <div className="row ">
              <div className="col-lg-6 col-sm-6 col-xs-4 mx-auto">
                <Table striped bordered hover className="mt-3">
                  <thead>
                    <tr className="text-dark">
                      <th>Member No</th>
                      <th>Member Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {suretyShortDetails?.length === 0 ? (
                      <tr>
                        <td colSpan={2} className="text-center">
                          Sorry, no matching records found
                        </td>
                      </tr>
                    ) : (
                      suretyShortDetails?.map((detail, index) => (
                        <tr key={index}>
                          <td>{detail.SuretyMember}</td>
                          <td>{detail.FullName}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        )}
        <div className="d-flex justify-content-center align-items-center">
          {isShortSuretyDetailsAvailable || isLongSuretyDetailsAvailable ? (
            <>
              <div className="text-center">
                <ButtonComponent
                  className="btn btn-primary btn-back border-0"
                  icon={"far fa-hand-point-left"}
                  value={"Back"}
                  onClick={() => {
                    navigate("/DemandRecovery");
                  }}
                />
              </div>
              <div className="text-center ml-3">
                <ButtonComponent
                  className="text-center btn-submit"
                  icon={"fas fa-eye"}
                  value={"Initiate Recovery"}
                  onClick={() => {
                    
                    // navigate("/SuretyMemberView");
                    handleShow();
                  }}
                />
              </div>
            </>
          ) : (
            <p>Sorry, no matching records found.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default DemandRecoveryForm;
